import { Typography } from "@earned/core";
import { FC } from "react";

interface ZeroStateProps {
  title: string;
}

const ZeroTaskState: FC<ZeroStateProps> = ({ title }) => {
  return (
    <div className="flex max-w-[1060px] flex-row rounded-lg bg-white p-4 shadow-md">
      <Typography variant="body" weight="medium" color="primary">
        {title}
      </Typography>
    </div>
  );
};

export default ZeroTaskState;
